import { render, staticRenderFns } from "./IntegrationsForm.vue?vue&type=template&id=1487c5b4"
import script from "./IntegrationsForm.vue?vue&type=script&lang=js"
export * from "./IntegrationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports